// Round-trip charges for a long option (buy, then sell) — mirrors the backend's TradeCosts
// defaults: brokerage ₹35/order, STT 0.15% of sell premium, exchange txn 0.03503% (NSE) /
// 0.0325% (BSE) and SEBI 0.0001% of buy+sell premium, stamp 0.003% of buy premium, GST 18% on
// brokerage + exchange + SEBI. Keep in step with backend costs.* properties.
export const BROKERAGE_PER_ORDER = 35;
const GST_PCT = 18;
const BSE_SYMBOLS = new Set(['SENSEX', 'BANKEX']);

export const roundTripCharges = (symbol, buyPx, sellPx, qty) => {
  if (!qty || qty <= 0) return 0;
  const buyVal  = Math.max(buyPx ?? 0, 0) * qty;
  const sellVal = Math.max(sellPx ?? buyPx ?? 0, 0) * qty;
  const brokerage = BROKERAGE_PER_ORDER * 2;
  const txn   = (BSE_SYMBOLS.has(symbol) ? 0.0325 : 0.03503) / 100 * (buyVal + sellVal);
  const sebi  = 0.0001 / 100 * (buyVal + sellVal);
  const stt   = 0.15 / 100 * sellVal;
  const stamp = 0.003 / 100 * buyVal;
  const gst   = GST_PCT / 100 * (brokerage + txn + sebi);
  return Math.round(brokerage + txn + sebi + stt + stamp + gst);
};

// Net ₹ of a closed trade row after all charges, or null without P&L / quantity — the backend's
// TradeCosts.netRsOf: multi-leg rows carry chargesRs summed per leg at close; a row with no
// prices is charged brokerage + GST only.
export const netRsOf = t => {
  if (t.pnlPts == null || t.allocatedLotSize == null) return null;
  const qty = t.allocatedLotSize;
  const charges = t.chargesRs != null ? t.chargesRs
    : t.entryLTP != null && t.exitLTP != null && qty > 0 ? roundTripCharges(t.symbol, t.entryLTP, t.exitLTP, qty)
    : BROKERAGE_PER_ORDER * 2 * (1 + GST_PCT / 100);
  return Number(t.pnlPts) * qty - charges;
};
